module.exports = __webpack_public_path__ + "img/combinator-displays.361a850b.png";